<div class="min-h-screen xl:flex">
  <div>
    <!-- Menú lateral: oculto en escritorio cuando la disposición es 'topnav'.
         En pantallas estrechas (< xl) sigue actuando como cajón, sea cual sea la disposición. -->
    <app-sidebar-menu [ngClass]="{ 'xl:hidden': navLayout() === 'topnav' }"></app-sidebar-menu>
    <app-backdrop></app-backdrop>
  </div>
  <!-- `min-w-0` es la mitad que faltaba de `flex-1`.

       Un hijo de flex no se encoge por debajo de su contenido mientras su mínimo automático lo
       sostenga. Sin esto, cualquier pantalla con algo intrínsecamente ancho —un tablero kanban,
       una tabla larga, una fila de botones que no envuelve— estiraba esta columna, la columna
       estiraba la página, y lo que se veía era la cabecera fija desalineada y todo corrido: la
       «distorsión visual» que aparece al hacer zoom, porque el zoom estrecha el área de contenido
       y el contenido deja de caber.

       Con el mínimo en cero la columna se queda en su sitio y cada pantalla resuelve su propio
       desborde donde ya sabe hacerlo: el kanban con su `overflow-x-auto`, las tablas con el suyo. -->
  <div
      class="min-w-0 flex-1 transition-all duration-300 ease-in-out"
      [ngClass]="{
        'xl:ml-[290px]': navLayout() === 'sidebar' && ((isExpanded$ | async) || (isHovered$ | async)),
        'xl:ml-[90px]': navLayout() === 'sidebar' && !((isExpanded$ | async) || (isHovered$ | async)),
        'xl:ml-0': navLayout() === 'topnav',
        'ml-0': (isMobileOpen$ | async)
      }"
  >
    <!-- app header start -->
    <app-header/>
    <!-- app header end -->

    <!-- Barra de navegación horizontal: solo en escritorio y solo en modo 'topnav' -->
    @if (navLayout() === 'topnav') {
      <app-top-nav class="hidden xl:block"></app-top-nav>
    }

    <!-- Contenedor de página. Por defecto se centra con un tope de ancho, que es lo que quiere una
         pantalla de formulario o de tabla: una línea de texto de 2000 px no se lee.

         Las pantallas que se declaran de ancho completo (`anchoCompleto` en los datos de la ruta)
         se lo saltan. Son las que no son un documento sino una aplicación dentro de la aplicación
         —Tareas, con su árbol fijo a la izquierda— y que ya sangran hasta los bordes con márgenes
         negativos. Con el tope puesto, el sangrado llegaba al borde de un contenedor que no era el
         del área de contenido, y quedaba una franja muerta a cada lado (INC-0024). -->
    <div class="p-4 md:p-6" [ngClass]="anchoCompleto() ? '' : 'mx-auto max-w-(--breakpoint-2xl)'">
      <router-outlet></router-outlet>
      <app-modal-host></app-modal-host>
      <app-celebration-overlay></app-celebration-overlay>
    </div>
  </div>
</div>
